<template>
    <Slide :title="title" :subtitle="subtitle">
        <div v-if="registrationStore.bdm" class="cr:border cr:border-gray-200 cr:rounded-lg cr:p-4 cr:mt-2">
            <p class="cr:text-sm cr:text-gray-500 cr:mb-2">You will be hearing from</p>
            <p class="cr:font-semibold cr:text-gray-900">{{ registrationStore.bdm.name }}</p>
            <div class="cr:mt-2 cr:space-y-1">
                <p>
                    <a :href="`mailto:${registrationStore.bdm.email}`" class="cr:text-blue-500">
                        {{ registrationStore.bdm.email }}
                    </a>
                </p>
                <p v-if="registrationStore.bdm.phone">
                    <a :href="`tel:${registrationStore.bdm.phone}`" class="cr:text-blue-500">
                        {{ registrationStore.bdm.phone }}
                    </a>
                </p>
            </div>

            <div v-if="registrationStore.bdm.meeting_url" class="cr:mt-4">
                <a
                    :href="registrationStore.bdm.meeting_url"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="cr:inline-block cr:w-full cr:text-center cr:bg-[#131C24] hover:cr:bg-[#1f2b35] cr:text-white cr:font-semibold cr:px-6 cr:py-3 cr:rounded-lg cr:transition-colors cr:duration-300"
                >
                    Book a Demo
                </a>
            </div>
        </div>

        <div v-else class="cr:mt-2">
            <p class="cr:text-gray-600">If you have any questions in the meantime, feel free to reach out to our support team.</p>
            <div class="cr:mt-2 cr:space-y-1">
                <p>Phone: <a :href="`tel:${configStore.supportPhone}`" class="cr:text-blue-500">{{ configStore.supportPhone }}</a></p>
                <p>Email: <a :href="`mailto:${configStore.supportEmail}`" class="cr:text-blue-500">{{ configStore.supportEmail }}</a></p>
            </div>
        </div>

        <p class="cr:pt-4 cr:text-gray-600">Thank you for joining us. We look forward to helping you grow your business.</p>
    </Slide>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {useConfigStore} from "@/stores/config.ts";
import {useRegistrationV4Store} from "@/stores/registrationV4.ts";
import Slide from "@/components/slides/Slide.vue";

const configStore = useConfigStore();
const registrationStore = useRegistrationV4Store();

const title = computed(() => "You're All Set!");

const subtitle = computed(() =>
    registrationStore.bdm
        ? 'Your registration was received and a Sales Rep has been assigned to your account.'
        : 'Your registration was received. Our team will be in touch shortly.'
);
</script>
